import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
// import { MdClose } from "react-icons/md";
import axios from "../../services/axios";
// import UserContext from "../../context/userContext.js";
import CloseModalButton from "../../assets/img/lupa/TNCDigital_Web_Cercador_3.svg";
import "./RequestVisionExpiredModal.css";

import FocusTrap from 'focus-trap-react';

const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
  left: 0;
`;

const ModalWrapper = styled.div`
  width: 390px;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
  background: #fff;
  color: #000;
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: relative;
  z-index: 90;
  border-radius: 0px;
  margin-top: 170px;
  margin-bottom: 150px;
`;

// const ModalImg = styled.img`
//   width: 100%;
//   height: 100%;
//   border-radius: 10px 0 0 10px;
//   background: #000;
// `;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1.8;
  color: #141414;

 

  button {
    padding: 10px 24px;
    background: #141414;
    color: #fff;
    border: none;
  }
`;

export const RequestVisionExpiredModal = ({ showModal, setShowModal, lang, isLoggedFunc,accepteVisionTerm }) => {
  // , lang, movie = {}   arriba
 
  const modalRef = useRef();
  // const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const [emailLabel, setEmailLabel] = useState("");
  const [passwordLabel, setPasswordLabel] = useState("");
  // const [buttonLabel, setButtonLabel] = useState("");
  const [initMessageLabel, setInitMessageLabel] = useState("");
  const [textForm, setTextForm] = useState("");
  const [textButton, setTextButton] = useState("");
  const [linkTextLabel, setLinkTextLabel] = useState("");
  const [linkLabel, setLinkLabel] = useState("");

  // const [messageZonePersonal, setMessageZonePersonal] = useState("");

  const [showLink, setShowLink] = useState(false);

  const [showAcceptedButton,setShowAcceptButton]=useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const[acceptConditionLabel,setAcceptConditionLabel]=useState("");
  const[acceptButtonLabel,setAcceptButtonLabel]=useState("");

  const parraRef2 = useRef(null);
  //const [initMessageLabel, setInitMessageLabel] = useState("");
 
 // const [modalMessageLabel,setModalMessagelabel]=useState("");

  /*Label*/

  /*End Label*/
  // const animation = useSpring({
  //   config: {
  //     duration: 450,
  //   },
  //   opacity: showModal ? 1 : 0,
  //   transform: showModal ? `translateY(0%)` : `translateY(-10%)`,
  // });
  

  useEffect(() => {
    console.log('cargando modal...');
    if(parraRef2.current){
      parraRef2.current.scrollTop = 0;
      //document.getElementById("parraRef").scroll({top:0,behavior:'smooth'});
      }


   /* function keyListener(e) {
      const listener = keyListenersMap.get(e.keyCode);
      return listener && listener(e);
    }
    document.addEventListener("keydown", keyListener);

    return () => document.removeEventListener("keydown", keyListener);*/
  });
  /*const handleTabKey = e => {
    console.log('load');
    if(modalRef.current != undefined)
    {
    const focusableModalElements = modalRef.current.querySelectorAll(
      'a[href], button[type="submit"], textarea, input[type="text"],input[type="password"], input[type="radio"], input[type="checkbox"], select'
    );
    const firstElement = focusableModalElements[0];
    
  }
  };*/

  //const keyListenersMap = new Map([[9, handleTabKey]]);


  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false);
    }
  };

  useEffect(() => {
    setMessage("");
    setShowLink(false);
   

    if (lang === "cat") {
      setEmailLabel("Correu");
      setPasswordLabel("Finalitat d’us (*)");
      // setButtonLabel("Entra");
      setInitMessageLabel("VISIONAT DE CONTINGUT");
      setTextForm("Introdueix les dades d’accés de la teva a la Zona personal");
     
      setTextButton("Iniciar sessió");
      setLinkTextLabel("Zona personal");
      setLinkLabel(
        "https://entrades.tnc.cat/ca/zona-personal?_ga=2.42963173.1978070969.1615183630-1231063336.1568644859"
      );
      setAcceptConditionLabel("Accepto les condicions de visionat de contingut");
      setAcceptButtonLabel("Accepto");
     
    }
    if (lang === "esp") {
      setEmailLabel("Correo");
      setPasswordLabel("Finalidad de uso (*)");
      // setButtonLabel("Entra");
      setInitMessageLabel("VISIONADO DE CONTENIDO");
      setTextForm("Introduce los datos de acceso de tu zona personal");
      setTextButton("Iniciar session");
      setLinkTextLabel("Zona personal");
      setLinkLabel(
        "https://entrades.tnc.cat/?action=PU_ident_unica&idioma=ES&act=1"
      );
      setAcceptConditionLabel("Acepto las condiciones de visionado de contenido");
      setAcceptButtonLabel("Accepto");
     
    }
    if (lang === "eng") {
      setEmailLabel("Email");
      setPasswordLabel("Purpose of use (*)");
      // setButtonLabel("Enter");
      setInitMessageLabel("VIEWING CONTENT");
      setTextForm("Log in your credentials of personal zone");
      setTextButton("Start session");
      setLinkTextLabel("Purpose of use");
      setLinkLabel(
        "https://entrades.tnc.cat/?action=PU_ident_unica&idioma=EN&act=19"
      );
      let rol =localStorage.getItem("rol");
      console.log('Rol es::'+rol);
      if (rol ==='PROFESOR')
      {
        setAcceptConditionLabel("I accept the content viewing conditions for academic use");
      }
      if (rol ==='PROFESIONAL')
      {
        setAcceptConditionLabel("I accept the content viewing conditions for professional use");
      }
      setAcceptConditionLabel("I accept the content viewing conditions");
      setAcceptButtonLabel("Accept");
    
      
    }

   

   
  }, [lang]);

  useEffect(() => {
    setMessage("");
    setPassword("");
    setEmail("");
    setShowLink(false);
    setShowAcceptButton(false);
    setErrorMessage("");
    console.log('abrir barra');
    console.log(parraRef2.current);
    if(parraRef2.current){
      console.log('subir scroll::');
      window.scrollTo({top:0, behavior: "smooth",});
      parraRef2.current.scrollTo({block:'start',behavior:'smooth'});
      document.getElementById("parraRef").scroll({top:0,behavior:'smooth'});
      console.log( parraRef2.current.pageYOffset);
      }
   
   
  }, [showModal]);
  

  function ValidateEmail(mail) {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        mail
      )
    ) {
      return true;
    }
    return false;
  }

  const checkLogin = async (email) => {
    console.log("email to validate", email, password);
    setShowLink(false);
    const validEmail = ValidateEmail(email);
    if (!email) {
      setShowLink(true);
      if (lang === "cat") {
        // setMessage("Correu és requerit");
        setMessage(
          "Correu o contrasenya incorrecta. Si us plau, comprova les teves dades d’accés a la "
        );
      }
      if (lang === "esp") {
        //setMessage("Correo es requerido");
        setMessage(
          "Email o contraseña incorrecta. Por favor, comprueba tus datos de acceso en la  "
        );
      }
      if (lang === "eng") {
        //setMessage("Email required");
        setMessage(
          "Wrong password o email. Please check your login credentials in the "
        );
      }

      return;
    } else if (!validEmail) {
      setShowLink(true);
      if (lang === "cat") {
        // setMessage("Email no vàlid");
        setMessage(
          "Correu o contrasenya incorrecta. Si us plau, comprova les teves dades d’accés a la "
        );
      }
      if (lang === "esp") {
        //  setMessage("Email no valido");
        setMessage(
          "Email o contraseña incorrecta. Por favor, comprueba tus datos de acceso en la  "
        );
      }
      if (lang === "eng") {
        //  setMessage("Invalid Email");
        setMessage(
          "Wrong password o email. Please check your login credentials in the "
        );
      }
    }

    if (!password) {
      setShowLink(true);
      if (lang === "cat") {
        //setMessage("Contrasenya és requerida");
        setMessage(
          "Correu o contrasenya incorrecta. Si us plau, comprova les teves dades d’accés a la "
        );
      }
      if (lang === "esp") {
        // setMessage("Contraseña es requerida");
        setMessage(
          "Email o contraseña incorrecta. Por favor, comprueba tus datos de acceso en la  "
        );
      }
      if (lang === "eng") {
        // setMessage("Password required");
        setMessage(
          "Wrong password o email. Please check your login credentials in the "
        );
      }

      return;
    }

    let params = {
      email: email,
      password: password,
    };
    if (validEmail) {
      axios
        .post(`/login`, params)
        .then((res) => {
          // console.log(res);
          /*persist in local storage*/
          if (res.data) {
            localStorage.setItem("expirationDate", res.data.expirationDate);
            localStorage.setItem("hasMemberShips", res.data.hasMemberships);
            localStorage.setItem("token", res.data.accessToken);
            localStorage.setItem("email", email);
            setShowModal(false);
            isLoggedFunc(true);
          }
        })
        .catch((err) => {
          if (err.response.status === 409) {
            setShowLink(true);
            if (lang === "cat") {
              setMessage(
                "Correu o contrasenya incorrecta. Si us plau, comprova les teves dades d’accés a la "
              );
            }
            if (lang === "esp") {
              setMessage(
                "Email o contraseña incorrecta. Por favor, comprueba tus datos de acceso en la  "
              );
            }
            if (lang === "eng") {
              setMessage(
                "Wrong password o email. Please check your login credentials in the "
              );
            }
          } else {
            if (lang === "cat") {
              setMessage("S'ha produït un error, torna a intentar-ho");
            }
            if (lang === "esp") {
              setMessage("Se ha producido algún error, vuelve a intentarlo");
            }
            if (lang === "eng") {
              setMessage("It has been an error. Try again, please.");
            }
          }
        });
    }
  };
  const signIn = (e) => {

    console.log(e);
    e.preventDefault();
    //put in the datalayer
    // the user just logged in / the user was logged in
    // console.log("Email::", email);
    setMessage("");
    checkLogin(email);
    /* auth
            .signInWithEmailAndPassword(email, password)
            .then(auth => {
                history.push('/')
            })
            .catch(error => alert(error.message))*/
  };

  function onKeyPressed(e) {
    console.log(e.key);
    if(e.keyCode === 13)
    {
      setShowModal(false);
    }
    
    
   };
  
  
   // handle check accepted terms
   const checkterm = (e) => {

    //test scroll
    document.getElementById("parraRef").scroll({top:0,behavior:'smooth'});

    console.log(document.getElementById('b'));
    if(document.getElementById('b').checked === true)
    {
      console.log('selected');
      setShowAcceptButton(true);
    }
    else
    {
      setShowAcceptButton(false);
    }
  };
//validate finalidad
  const checkUseFor = () => {
   
    if(!password)
    {
      //setShowValidMessage(true);
       if(lang==='esp')
       {
        setErrorMessage("El campo es mandatorio mandatorio");
       }
       if(lang ==='cat')
       {
        setErrorMessage("Aquest camp és mandatori");
       }
       if(lang ==='eng')
       {
        setErrorMessage("field is required");
       }
      
    }
    else
    {
      //call accepted term
      accepteVisionTerm(password);

    }
  };
  

  return (
    <>
      {showModal ? (
        <Background onClick={closeModal} ref={modalRef}>
          {/* <animated.div style={animation}> */}
         {/* <FocusTrap active={showModal} >*/}
          <ModalWrapper showModal={showModal}>
            {/*<ModalImg src={require('./modal.jpg')} alt='camera' />*/}
            <ModalContent>
              <div className="login__container_expired_modal" role="dialog" arial-modal="true">
                <p className="login__container__title">{initMessageLabel}</p>
               { lang ==='cat' && <div id="parraRef" ref={parraRef2}  className="titleTextForm_expired_vision">
               <div> 
                El termini de visionat d’aquest espectacle ha expirat. Escriviu a <a target="_blank" className="message_link">serveieducatiu@tnc.cat</a> per sol·licitar l’ampliació del termini.       
              </div>
</div>  }
{ lang ==='eng' && <> <p className="titleTextForm_expired_vision">
The period for visualising the show has been expired. Please, email to <a target="_blank" className="message_link">serveieducatiu@tnc.cat</a> to request an extension of the period.
</p></>}
{ lang ==='esp' && <p className="titleTextForm_expired_vision">
El plazo de visionado de este espectáculo ha expirado. Escriba a <a target="_blank" className="message_link" >serveieducatiu@tnc.cat</a> para solicitar la ampliación del plazo.
</p>  }
               
             
             
             
              </div>
            </ModalContent>
            <div onKeyDown={onKeyPressed}>
            <img
             tabindex="0"
              src={CloseModalButton}
              alt="close_button"
              className="close_button"
              onClick={() => setShowModal((prev) => !prev)}
            />
            </div>
          </ModalWrapper>
        
          {/* </animated.div> */}
        </Background>
      ) : null}
    </>
  );
};
